var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#C7C7C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.618 20.7422C16.6355 20.7646 16.6579 20.7827 16.6835 20.7952C16.7091 20.8077 16.7372 20.8141 16.7656 20.8141C16.7941 20.8141 16.8222 20.8077 16.8477 20.7952C16.8733 20.7827 16.8957 20.7646 16.9133 20.7422L19.5383 17.4211C19.6344 17.2992 19.5477 17.1187 19.3906 17.1187H17.6539V9.1875C17.6539 9.08437 17.5695 9 17.4664 9H16.0602C15.957 9 15.8727 9.08437 15.8727 9.1875V17.1164H14.1406C13.9836 17.1164 13.8969 17.2969 13.993 17.4188L16.618 20.7422ZM25.3438 19.9219H23.9375C23.8344 19.9219 23.75 20.0062 23.75 20.1094V23.7188H9.78125V20.1094C9.78125 20.0062 9.69688 19.9219 9.59375 19.9219H8.1875C8.08437 19.9219 8 20.0062 8 20.1094V24.75C8 25.1648 8.33516 25.5 8.75 25.5H24.7812C25.1961 25.5 25.5312 25.1648 25.5312 24.75V20.1094C25.5312 20.0062 25.4469 19.9219 25.3438 19.9219Z",
    fill: "#0E0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.b5bc66c45717f98cb2fd12dc07499be0.svg";
export { ForwardRef as ReactComponent };